let deferred = null;
const listeners = new Set();
const emit = () => listeners.forEach((f) => f());

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export function device() {
  const ua = navigator.userAgent;
  const ios = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const android = /Android/.test(ua);
  return { ios, android, safari: ios && !/CriOS|FxiOS|EdgiOS/.test(ua), desktop: !ios && !android };
}

export function deviceName() {
  const ua = navigator.userAgent;
  const d = device();
  const os = d.ios ? (/iPad/.test(ua) ? "iPad" : "iPhone") : d.android ? "Android" : /Windows/.test(ua) ? "Windows" : /Mac/.test(ua) ? "Mac" : "Computer";
  const browser = /Edg\//.test(ua) ? "Edge" : /CriOS|Chrome\//.test(ua) ? "Chrome" : /Firefox|FxiOS/.test(ua) ? "Firefox" : /Safari/.test(ua) ? "Safari" : "Browser";
  return `${os} · ${isStandalone() ? "Installed app" : browser}`;
}

export function initPwa() {
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; emit(); });
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
  }
}

export const canInstall = () => !!deferred;
export const onInstallChange = (f) => { listeners.add(f); return () => listeners.delete(f); };

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const { outcome } = await deferred.userChoice;
  deferred = null;
  emit();
  return outcome === "accepted";
}

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export function pushState() {
  if (device().ios && !isStandalone()) return "ios-not-installed";
  if (!pushSupported()) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  return "ok";
}

const keyBytes = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export async function subscribePush(api) {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { status: perm === "denied" ? "denied" : "dismissed" };
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  let sub = await reg.pushManager.getSubscription();
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: keyBytes(data.public_key) });
  const j = sub.toJSON();
  const { data: saved } = await api.post("/push/subscriptions", { endpoint: j.endpoint, keys: j.keys, device: deviceName() });
  localStorage.setItem("dls_push_sub", saved.id);
  return { status: "ok", sub: saved };
}

export async function unsubscribeLocal() {
  localStorage.removeItem("dls_push_sub");
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg && (await reg.pushManager.getSubscription());
  if (sub) await sub.unsubscribe();
}

export const thisDeviceSubId = () => localStorage.getItem("dls_push_sub");
